webpackJsonp([0],{

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(745);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CookiePolicy.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./CookiePolicy.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, "._3YN-Z{-webkit-box-sizing:border-box;box-sizing:border-box;color:#141414;height:auto;width:100%;padding:0;margin:0;font:400 16px/22px var(--font-family-base)}._1UE7B{height:40vh;min-height:300px;width:100%;background:url(https://assets.ey.com/content/dam/ey-sites/ey-com/en_in/topics/climate-change/2021/05/ey-esg-integration-into-business.jpg.rendition.1800.1200.jpg) #1a1a24;background-size:cover;background-blend-mode:multiply;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-webkit-clip-path:ellipse(74% 57% at 50% 32%);clip-path:ellipse(74% 57% at 50% 32%);color:#fff;font:100 40px/48px var(--font-family-base);letter-spacing:2.3px}._35B9G{color:#141414;max-width:900px;margin:0 auto;font:400 16px/22px var(--font-family-base);padding:80px 20px 0}._35B9G,._35B9G h1{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;width:100%}._35B9G h1{color:#333;text-align:left;-webkit-text-decoration:none solid #333;text-decoration:none solid #333;font:400 32px/22px var(--font-family-base);margin:0 0 16px;outline:0 none #333}._35B9G h2{opacity:.8;text-align:left;font:normal normal 400 normal 25px/31.25px var(--font-family-base);margin:0 0 16px}._35B9G h2,._35B9G h3{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;width:100%}._35B9G h3{opacity:.45;font:normal normal 400 normal 20px/23px var(--font-family-base);margin:0}._35B9G p{height:auto;opacity:.65;width:100%;margin:0 0 32px}._35B9G a,._35B9G p{-webkit-box-sizing:border-box;box-sizing:border-box;text-align:justify;font:normal normal 400 normal 16px/28px var(--font-family-base)}._35B9G a{color:#00f;-webkit-text-decoration:none solid #00f;text-decoration:none solid #00f;outline:0 none #00f}._35B9G ul{color:#141414;width:100%;font:400 16px/22px var(--font-family-base);margin:16px 0 48px}._35B9G li,._35B9G ul{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;list-style:outside none none}._35B9G li{bottom:0;left:0;opacity:.65;position:relative;right:0;top:0;width:80%;margin:0 0 16px;padding:0 0 0 40px}._35B9G li,._35B9G li:before{text-align:justify;font:normal normal 300 normal 18px/27px var(--font-family-base)}._35B9G li:before{bottom:33px;content:\"\";display:block;left:13px;position:absolute;top:6px;width:13px;height:13px;background:#d8d8d8 none repeat scroll 0 0/auto padding-box border-box;border:1px solid #979797;border-radius:50% 50% 50% 50%;list-style:outside none none}", ""]);

// exports
exports.locals = {
	"root": "_3YN-Z",
	"banner": "_1UE7B",
	"section": "_35B9G"
};

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(747);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Gdpr.css", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Gdpr.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports


// module
exports.push([module.i, ".DCtMz{-webkit-box-sizing:border-box;box-sizing:border-box;color:#141414;height:auto;width:100%;padding:0;margin:0;font:400 16px/22px var(--font-family-base)}._1tvvd{height:40vh;min-height:300px;width:100%;background:url(https://assets.ey.com/content/dam/ey-sites/ey-com/en_in/topics/climate-change/2021/05/ey-esg-integration-into-business.jpg.rendition.1800.1200.jpg) #1a1a24;background-size:cover;background-blend-mode:multiply;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-webkit-clip-path:ellipse(74% 57% at 50% 32%);clip-path:ellipse(74% 57% at 50% 32%);color:#fff;font:100 40px/48px var(--font-family-base);letter-spacing:2.3px}._1X0Lv{color:#141414;max-width:900px;margin:0 auto;font:400 16px/22px var(--font-family-base);padding:80px 20px 0}._1X0Lv,._1X0Lv h1{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;width:100%}._1X0Lv h1{color:#333;text-align:left;-webkit-text-decoration:none solid #333;text-decoration:none solid #333;font:400 32px/22px var(--font-family-base);margin:0 0 16px;outline:0 none #333}._1X0Lv h2{opacity:.8;text-align:left;font:normal normal 400 normal 25px/31.25px var(--font-family-base);margin:0 0 16px}._1X0Lv h2,._1X0Lv h3{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;width:100%}._1X0Lv h3{opacity:.45;font:normal normal 400 normal 20px/23px var(--font-family-base);margin:0}._1X0Lv p{height:auto;opacity:.65;width:100%;margin:0 0 32px}._1X0Lv a,._1X0Lv p{-webkit-box-sizing:border-box;box-sizing:border-box;text-align:justify;font:normal normal 400 normal 16px/28px var(--font-family-base)}._1X0Lv a{color:#00f;-webkit-text-decoration:none solid #00f;text-decoration:none solid #00f;outline:0 none #00f}._1X0Lv ul{color:#141414;width:100%;font:400 16px/22px var(--font-family-base);margin:16px 0 48px}._1X0Lv li,._1X0Lv ul{-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;list-style:outside none none}._1X0Lv li{bottom:0;left:0;opacity:.65;position:relative;right:0;top:0;width:80%;margin:0 0 16px;padding:0 0 0 40px}._1X0Lv li,._1X0Lv li:before{text-align:justify;font:normal normal 300 normal 18px/27px var(--font-family-base)}._1X0Lv li:before{bottom:33px;content:\"\";display:block;left:13px;position:absolute;top:6px;width:13px;height:13px;background:#d8d8d8 none repeat scroll 0 0/auto padding-box border-box;border:1px solid #979797;border-radius:50% 50% 50% 50%;list-style:outside none none}", ""]);

// exports
exports.locals = {
	"root": "DCtMz",
	"banner": "_1tvvd",
	"section": "_1X0Lv"
};

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 12 modules
var Layout = __webpack_require__(238);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./src/routes/legal/cookiePolicy/CookiePolicy.css
var cookiePolicy_CookiePolicy = __webpack_require__(744);
var CookiePolicy_default = /*#__PURE__*/__webpack_require__.n(cookiePolicy_CookiePolicy);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(77);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/routes/legal/cookiePolicy/BannerArea.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = _jsx("span", {});

var _ref2 = _jsx("span", {});

var _ref3 = _jsx("span", {});

var _ref4 = _jsx("span", {});

var _ref5 = _jsx("span", {});

var _ref6 = _jsx("span", {});

var _ref7 = _jsx("span", {});

var _ref8 = _jsx("path", {
  fill: "#ffffff",
  d: "M0,24l0.01-0.24V0H240v24c0,0-48.115-23.471-120.039-23.48C48.018,0.52,0,24,0,24L0,24z"
});

var BannerArea_SignIn =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignIn, _React$Component);

  function SignIn() {
    _classCallCheck(this, SignIn);

    return _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).apply(this, arguments));
  }

  _createClass(SignIn, [{
    key: "render",
    value: function render() {
      var s = this.props.styles;
      return _jsx("div", {}, void 0, _jsx("section", {
        className: s.agencyBannerArea
      }, void 0, _jsx("div", {
        className: s.bubble
      }, void 0, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7), _jsx("div", {
        className: s.agencyBanner
      }, void 0, _jsx("div", {
        className: s.devider
      }, void 0, _jsx("svg", {
        className: classnames_default()(s.uncodeRowDivider, s.uncodeRowDividerCurve),
        x: "0px",
        y: "0px",
        width: "240px",
        height: "24px",
        viewBox: "0 0 240 24",
        enableBackground: "new 0 0 240 24",
        xmlSpace: "preserve",
        preserveAspectRatio: "none"
      }, void 0, _ref8))), this.props.children));
    }
  }]);

  return SignIn;
}(react_default.a.Component);

/* harmony default export */ var BannerArea = (BannerArea_SignIn);
// CONCATENATED MODULE: ./src/routes/legal/cookiePolicy/CookiePolicy.js
function CookiePolicy__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { CookiePolicy__typeof = function _typeof(obj) { return typeof obj; }; } else { CookiePolicy__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return CookiePolicy__typeof(obj); }

var CookiePolicy_REACT_ELEMENT_TYPE;

function CookiePolicy__jsx(type, props, key, children) { if (!CookiePolicy_REACT_ELEMENT_TYPE) { CookiePolicy_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: CookiePolicy_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function CookiePolicy__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CookiePolicy__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function CookiePolicy__createClass(Constructor, protoProps, staticProps) { if (protoProps) CookiePolicy__defineProperties(Constructor.prototype, protoProps); if (staticProps) CookiePolicy__defineProperties(Constructor, staticProps); return Constructor; }

function CookiePolicy__possibleConstructorReturn(self, call) { if (call && (CookiePolicy__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function CookiePolicy__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CookiePolicy__ref = CookiePolicy__jsx("p", {}, void 0, "A cookie is a piece of software code that an internet web site sends to your browser when you access information at that site. A cookie is stored as a simple text file on your computer or mobile device by a website\u2019s server and only that server will be able to retrieve or read the contents of that cookie. Cookies let you navigate between pages efficiently as they store your preferences, and generally improve your experience of a website. We use following types of cookies to enhance your experience and interactivity :");

var CookiePolicy__ref2 = CookiePolicy__jsx("ul", {}, void 0, CookiePolicy__jsx("li", {}, void 0, "Analytics cookies for anonymously remembering your computer or mobile device when you visit our website to keep track of browsing patterns."), CookiePolicy__jsx("li", {}, void 0, "Service cookies for helping us to make our website work efficiently, remembering your registration and login details, settings preferences, and keeping track of the pages you view."), CookiePolicy__jsx("li", {}, void 0, "Non-persistent cookies a.k.a per-session cookies. Per-session cookies serve technical purposes of providing seamless navigation. These cookies do not collect personal information on users and they are deleted as soon as you leave our website. The cookies do not permanently record data and they are not stored on your computer\u2019s hard drive. The cookies are stored in memory and are only available during an active browser session. Again, once you close your browser, the cookie disappears."));

var CookiePolicy__ref3 = CookiePolicy__jsx("p", {}, void 0, "You may note additionally that when you visit our platform, you may be required to accept cookies. If you choose to have your browser refuse cookies, it is possible that our platform may not function properly.");

var CookiePolicy_CookiePolicy =
/*#__PURE__*/
function (_React$Component) {
  CookiePolicy__inherits(CookiePolicy, _React$Component);

  function CookiePolicy() {
    CookiePolicy__classCallCheck(this, CookiePolicy);

    return CookiePolicy__possibleConstructorReturn(this, (CookiePolicy.__proto__ || Object.getPrototypeOf(CookiePolicy)).apply(this, arguments));
  }

  CookiePolicy__createClass(CookiePolicy, [{
    key: "render",
    value: function render() {
      return CookiePolicy__jsx("div", {
        className: CookiePolicy_default.a.root
      }, void 0, CookiePolicy__jsx("div", {
        className: CookiePolicy_default.a.banner
      }, void 0, "COOKIE POLICY"), CookiePolicy__jsx("div", {
        className: CookiePolicy_default.a.section
      }, void 0, CookiePolicy__ref, CookiePolicy__ref2, CookiePolicy__ref3));
    }
  }]);

  return CookiePolicy;
}(react_default.a.Component);

/* harmony default export */ var legal_cookiePolicy_CookiePolicy = (withStyles_default()(CookiePolicy_default.a)(CookiePolicy_CookiePolicy));
// CONCATENATED MODULE: ./src/routes/legal/cookiePolicy/index.js
var cookiePolicy_REACT_ELEMENT_TYPE;

function cookiePolicy__jsx(type, props, key, children) { if (!cookiePolicy_REACT_ELEMENT_TYPE) { cookiePolicy_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: cookiePolicy_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }




var title = 'Legal - Cookie Policy';

var cookiePolicy__ref = cookiePolicy__jsx(Layout["a" /* default */], {}, void 0, cookiePolicy__jsx(legal_cookiePolicy_CookiePolicy, {}));

function action() {
  return {
    chunks: ['cookiePolicy'],
    title: title,
    component: cookiePolicy__ref
  };
}

/* harmony default export */ var cookiePolicy = __webpack_exports__["default"] = (action);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(11);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./src/routes/legal/gdpr/Gdpr.css
var gdpr_Gdpr = __webpack_require__(746);
var Gdpr_default = /*#__PURE__*/__webpack_require__.n(gdpr_Gdpr);

// CONCATENATED MODULE: ./src/routes/legal/gdpr/Gdpr.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref = _jsx("h1", {}, void 0, "Spotmentor is GDPR ready");

var _ref2 = _jsx("p", {}, void 0, "Last Updated: 10th November, 2019");

var _ref3 = _jsx("p", {}, void 0, "We\u2019re committed to protecting our customers\u2019 data. We\u2019ve especially developed processes, technologies, and policies that ensure we deliver on our data security promise.");

var _ref4 = _jsx("p", {}, void 0, "The really good thing is that our already-in-place privacy and security practices align with the requirements of the GDPR regulation. And that is why more than 1,500 businesses count on us to keep their data safe and secure.");

var _ref5 = _jsx("h2", {}, void 0, "What really is GDPR?");

var _ref6 = _jsx("p", {}, void 0, "First off, in case you were wondering, GDPR stands for General Data Protection Regulation. Broadly speaking, it aims to simplify and streamline the data regulatory environment for businesses.");

var _ref7 = _jsx("p", {}, void 0, "At its core, GDPR is a new set of rules designed to give EU citizens more control over their personal data. It adds a list of new requirements about how companies should protect individuals\u2019 personal data they collect and use.");

var _ref8 = _jsx("p", {}, void 0, "In the simplest of words, GDPR aims to control how individuals and organizations may obtain, use, store, and remove personal data. EU citizens will now have complete control over their personal data.");

var _ref9 = _jsx("p", {}, void 0, "You can read all about GDPR", ' ', _jsx("a", {
  href: "https://gdpr-info.eu/ "
}, void 0, "here."));

var _ref10 = _jsx("h2", {}, void 0, "Is Spotmentor GDPR compliant?");

var _ref11 = _jsx("p", {}, void 0, "By all means. Spotmentor is fully compliant with the GDPR guidelines.");

var _ref12 = _jsx("p", {}, void 0, "We have always been extremely careful about handling our customers\u2019 data and our existing security practices already met most aspects of the new data privacy rules.");

var _ref13 = _jsx("p", {}, void 0, "We still went ahead and undertook an extensive internal audit to ensure we comply with all the GDPR regulations.");

var _ref14 = _jsx("h2", {}, void 0, "Does Spotmentor have a Data Protection Officer?");

var _ref15 = _jsx("p", {}, void 0, "Yes, we\u2019ve appointed a Data Protection Representative who will ensure that our employees across teams are trained on the requirements of the regulation and comply with it.");

var _ref16 = _jsx("p", {}, void 0, "The DPO is responsible for:");

var _ref17 = _jsx("ul", {}, void 0, _jsx("li", {}, void 0, "Educating the company and employees on important compliance requirements"), _jsx("li", {}, void 0, "Training staff involved in data processing"), _jsx("li", {}, void 0, "Conducting audits to ensure compliance and address potential issues proactively"), _jsx("li", {}, void 0, "Serving as the point of contact between the company and GDPR Supervisory Authorities"), _jsx("li", {}, void 0, "Monitoring performance and providing advice on the impact of data protection efforts"), _jsx("li", {}, void 0, "Maintaining comprehensive records of all data processing activities conducted by the company, including the purpose of all processing activities, which must be made public on request"), _jsx("li", {}, void 0, "Interfacing with data subjects to inform them about how their data is being used, their rights to have their personal data erased, and what measures the company has put in place to protect their personal information"));

var _ref18 = _jsx("h2", {}, void 0, "Safeguard Data Inventory");

var _ref19 = _jsx("h2", {}, void 0, "Consent");

var _ref20 = _jsx("p", {}, void 0, "We went ahead and updated our", ' ', _jsx("a", {
  href: "/legal/cookie-policy"
}, void 0, "Cookie Policy"), " to tell you clearly what information we collect when you visit the Spotmentor website, and how we use it. The page also explains how you can control your browser to accept or refuse cookies.");

var _ref21 = _jsx("h2", {}, void 0, "Right to erase");

var _ref22 = _jsx("p", {}, void 0, "In case a registered person needs to delete his details, the process for such deletion exists in the system. The request can be raised from the help section on the platform or you can contact our data protection officer. Your data will be deleted within 30 working days after raising the request.");

var _ref23 = _jsx("h2", {}, void 0, "Automated decision making");

var _ref24 = _jsx("p", {}, void 0, "We use automated decision making for profiling, if any person has any concerns with the results of the automated processing can object to such processing by stating the grounds of your objection to the data controller.");

var _ref25 = _jsx("h2", {}, void 0, "Internal training");

var _ref26 = _jsx("p", {}, void 0, "We\u2019ve ensured that our employees are trained on data privacy and GDPR guidelines. Everyone at Spotmentor is well versed with their responsibilities regarding security, process integrity, and confidentiality of customer data.");

var _ref27 = _jsx("h2", {}, void 0, "Updates to Terms of Service");

var _ref28 = _jsx("p", {}, void 0, "In the wake of the new rules, we went ahead and updated our Terms of Service to include the DPA and other clauses required by GDPR.");

var _ref29 = _jsx("h2", {}, void 0, "What kind of data does Spotmentor collect?");

var _ref30 = _jsx("p", {}, void 0, "When you use our product, our server saves the following details Database.");

var _ref31 = _jsx("ul", {}, void 0, _jsx("li", {}, void 0, "Email Id"), _jsx("li", {}, void 0, "Full name"), _jsx("li", {}, void 0, "Gender"), _jsx("li", {}, void 0, "Current Organisation name"), _jsx("li", {}, void 0, "Date of Joining/Quitting the organisation"), _jsx("li", {}, void 0, "Contact number"), _jsx("li", {}, void 0, "Resume"), _jsx("li", {}, void 0, "Work experience"), _jsx("li", {}, void 0, "Education details"));

var _ref32 = _jsx("p", {}, void 0, "That\u2019s all.");

var _ref33 = _jsx("h2", {}, void 0, "Have questions?");

var _ref34 = _jsx("p", {}, void 0, "Should you have any questions about GDPR or Data Privacy, you can always write the data protection officer at", ' ', _jsx("a", {
  href: "mailto:arpit@spotmentor.com",
  target: "_blank"
}, void 0, "arpit@spotmentor.com"));

var Gdpr_Gdpr =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Gdpr, _React$Component);

  function Gdpr() {
    _classCallCheck(this, Gdpr);

    return _possibleConstructorReturn(this, (Gdpr.__proto__ || Object.getPrototypeOf(Gdpr)).apply(this, arguments));
  }

  _createClass(Gdpr, [{
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: Gdpr_default.a.root
      }, void 0, _jsx("div", {
        className: Gdpr_default.a.banner
      }, void 0, "GDPR policy"), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref, _ref2, _ref3, _ref4), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref5, _ref6, _ref7, _ref8, _ref9), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref10, _ref11, _ref12, _ref13), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref14, _ref15, _ref16, _ref17), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref18, _jsx("p", {}, void 0, "We\u2019ve carefully identified the areas of Spotmentor where we collect user information and applied security and privacy safeguards across the entire ecosystem. At every step in our infrastructure, we ensure that we validate our legal basis for collecting and processing customer data.", ' ')), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref19, _ref20), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref21, _ref22), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref23, _ref24), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref25, _ref26), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref27, _ref28), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref29, _ref30, _ref31, _ref32), _jsx("div", {
        className: Gdpr_default.a.section
      }, void 0, _ref33, _ref34));
    }
  }]);

  return Gdpr;
}(react_default.a.Component);

/* harmony default export */ var legal_gdpr_Gdpr = (withStyles_default()(Gdpr_default.a)(Gdpr_Gdpr));
// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 12 modules
var Layout = __webpack_require__(238);

// CONCATENATED MODULE: ./src/routes/legal/gdpr/index.js
var gdpr_REACT_ELEMENT_TYPE;

function gdpr__jsx(type, props, key, children) { if (!gdpr_REACT_ELEMENT_TYPE) { gdpr_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: gdpr_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }





var gdpr__ref = gdpr__jsx(Layout["a" /* default */], {}, void 0, gdpr__jsx(legal_gdpr_Gdpr, {}));

function action() {
  return {
    title: 'Legal - GDPR policy',
    component: gdpr__ref
  };
}

/* harmony default export */ var gdpr = __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// cookiePolicy.bfec3cc2.chunk.js